import { render, staticRenderFns } from "./FormaKartica.vue?vue&type=template&id=2ff5137a"
import script from "./FormaKartica.vue?vue&type=script&lang=js"
export * from "./FormaKartica.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports